import HeaderMiddleBar from 'app/components/HeaderComponent/HeaderMiddleBar';
import ModulesInfo from './modulesInfo/ModulesInfo';
import React from 'react';
import TotalModulesInfo from './totalModulesInfo/TotalModulesInfo';
// LIVE BOM: temporarily hidden — uncomment to restore
// import LiveBomFreshnessBadge from 'bom/components/liveBom/LiveBomFreshnessBadge';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { panelsEditorEnabled } from '__editor/panelsEditor/panelsEditorHelper';
import { state } from '__common/store';
// LIVE BOM: temporarily hidden — uncomment to restore
// import { Box } from '@mui/material';

type Props = {
  projectId?: string,
};

export default class ProjectInfoHeaderMiddleBar extends React.Component<Props> {

  renderRightSiteInfoBar() {
    const { projectId } = this.props;
    const {projectConfiguration:{projectEnvConfig}} = state();
    // LIVE BOM: temporarily hidden — uncomment to restore
    // const isLiteRoute = window.location.pathname.indexOf('/lite/') !== -1;

    return (
      <div className="project-info project-header-summary">
        {projectId && <div className={projectEnvConfig?.aurora_design_id ? `project-id project-header-summary__id aurora` : `project-id project-header-summary__id`}>
          {/* <ContentCopyIcon className="summary-metric__icon project-header-summary__icon" /> */}
          <div className="total-modules-kw">
            <div  id="mid-bar-info">#ID</div>
            <div className="value" id="mid-bar-value">{projectId},</div>
          </div>
        </div>}
        <div className="modules project-header-summary__modules">
          {panelsEditorEnabled() ? <ModulesInfo /> : <TotalModulesInfo />}
        </div>
        {/* LIVE BOM: temporarily hidden — uncomment to restore
       <Box sx={{ width: '115px' }}>
  {projectId && !isLiteRoute && <LiveBomFreshnessBadge />}
</Box>
        */}
      </div>);
  }

  render() {
    const { projectId } = this.props;
    return (<HeaderMiddleBar projectId={projectId} rightSiteComponent={this.renderRightSiteInfoBar()} />);
  }
}


